const topLevelFieldValues = ['Yes', 'No'];

export default {
    visible: {
        default() {
            return true;
        },
        apply(values) {
            // If the first rule has Yes/No value, we treat it as the top level condition
            // we have a condition chain in array: [[topLevelArray], [secondLevelArray], [thirdLevelArray] ...]
            // all items directly in the chain is treatd as AND case, in each item the array is treated in OR case.
            const conditionChain = createConditionChain(values);
            return validateConditionChain(conditionChain);
        },
    },
    disabled: {
        default() {
            return false;
        },
        apply(values) {
            return values.some(({ value, rule }) => value === rule.value);
        },
    },
    override: {
        applied: false,
        default() {
            return this.applied;
        },
        apply(values) {
            return values.some(({ value, rule }) => value === rule.value);
        },
    },
};


function isMatched(currentSelectedField){
    return currentSelectedField.value === currentSelectedField.rule.value;
}

function createConditionChain(values) {
    const conditionChain = [[]];

    // Handle top level
    const topLevel = values[0];
    const isTopLevelIncluded = topLevelFieldValues.includes(topLevel.value);
    if(isTopLevelIncluded) {
        conditionChain[0].push(isMatched(topLevel));
        conditionChain.push([]);
    }

    // handle other children level
    values.forEach((currentLevel, idx) => {
        if (idx != 0 || !isTopLevelIncluded) {
            conditionChain[conditionChain.length - 1].push(isMatched(currentLevel));
        }
    })

    return conditionChain;
}

function validateConditionChain(conditionChain) {
    let andCaseTrueCount = 0;
    const andCaseTotal = conditionChain.length;
    for (let i = 0; i < andCaseTotal; i++) {
        if (
            conditionChain[i].length === 0 ||
            conditionChain[i].indexOf(true) > -1
        ) {
            andCaseTrueCount++;
        }
    }
    return andCaseTrueCount === andCaseTotal;
}
